import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
const ManageQuestionaire =  React.lazy(()=>import("./pages/Questionnaire/ManageQuestionaire/ManageQuestionaire"));
const CreateQuestionnaire = React.lazy(()=>import("./pages/Questionnaire/CreateQuestionnaire/CreateQuestionnaire"));
const JobPostConfirmation = React.lazy(()=>import("./pages/NewJobPosting/CompletedJobPosting")) ;

const NotFoundPage = lazy(() => import("./pages/404/NotFoundPage"));
const NewJobPosting = lazy(() => import("./pages/NewJobPosting/NewJobPosting"));

function AppRouter(props: any) {

  return (
    <Router>
      <Suspense>
        <Routes>
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/edge/jobposting/error" element={<NotFoundPage />} />
          <Route
            path={`/edge/jobposting/new-job-posting/copy/:id`}
            element={
              <NewJobPosting
              loginError={props.loginError}
              loginData={props.loginData}
              />
            }
          />
          <Route
            path={`/edge/jobposting/new-job-posting/edit/:id`}
            element={
              <NewJobPosting
              loginError={props.loginError}
              loginData={props.loginData}
              />
            }
          />
          <Route
            path="/edge/jobposting/new-job-posting"
            element={
              <NewJobPosting
              loginError={props.loginError}
              loginData={props.loginData}
              />
            }
          />
          <Route
            path="/edge/jobposting/create-questionnaire"
            element={<CreateQuestionnaire loginError={props.loginError}
            loginData={props.loginData}/>}
          />
          <Route
            path="/edge/jobposting/manage-questionnaire"
            element={<ManageQuestionaire loginError={props.loginError}
            loginData={props.loginData}/>}
          />
          <Route
            path="/edge/jobposting/confirmation"
            element={<JobPostConfirmation />}
          />
          <Route
            path={`/edge/jobposting/create-questionnaire/edit/:id`}
            element={<CreateQuestionnaire />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRouter;
